import React from "react";
import { useSelector } from "react-redux";
import { Helpers } from "../helpers/Helpers";
import { RootState } from "../redux/store";
import Box from "./Box";
import PagingSelect from "./PagingSelect";
import Small from "./Small";

/** "Tümü" seçeneğinin sunucuya giden sayfa boyu: tek sayfada bütün kayıtlar (sunucu Take kadar döndürür). */
export const TUMU_TAKE = 1000000;

interface Props {
    take: number
    totalPageCount: number
    currentPage: number
    performPagination: (_i: number) => void
    totalRecordCount: number
    changeTake: (_take: number) => void
    selectedCount?: number
    /** Verilirse sayfa boyu listesine "Tümü" eklenir (ör. Faturalanacaklar, 19.10.2026). */
    tumuSecenegi?: boolean
}

interface Props2 {
    active: boolean
    text: string,
    onClick: any
}

const TableFooter = ({ selectedCount, currentPage, performPagination, take, totalPageCount, totalRecordCount, changeTake, tumuSecenegi }: Props) => {
    const auth = useSelector((state: RootState) => state.auth)

    const PagingItem = ({ active, text, onClick }: Props2) => {
        return (
            <Box actionIcon onClick={onClick} borderRadius='4px' pl="4px" pr="4px" minWidth='30px' height='30px' bg={active ? '#1B84FF' : '#fff'} justifyContent='center'>
                <Small color={active ? '#F8F9FA' : '#343A40'} text={text} />
            </Box>
        )
    }

    return (
        <Box className="px-2 pb-2"  /*borderTop={'1px solid #E5E7EB'}*/ flexDirection='row'>
            <Box mr='24px' justifyContent='center'>
                <Small text={'Görüntülenen'} />
            </Box>
            <Box mr='24px' justifyContent='center'>
                <PagingSelect
                    changeTake={changeTake}
                    value={take.toString()}
                    items={[
                        { label: '1', value: '1' },
                        { label: '5', value: '5' },
                        { label: '10', value: '10' },
                        { label: '25', value: '25' },
                        { label: '50', value: '50' },
                        { label: '100', value: '100' },
                        { label: '250', value: '250' },
                        { label: '500', value: '500' },
                        { label: '1000', value: '1000' },
                        ...(tumuSecenegi ? [{ label: 'Tümü', value: TUMU_TAKE.toString() }] : []),
                    ]}
                />
            </Box>
            <Box justifyContent='center' flexDirection='row' alignItems='center'>
                <Small text={'Toplam' + ' ' + totalRecordCount} />
                {
                    (selectedCount != undefined && selectedCount > 0) && (
                        <span className='badge badge-light-danger ebbe-selected-count'>{selectedCount} seçili</span>
                    )
                }
            </Box>
            <Box flexGrow={1}>
                &nbsp;
            </Box>
            <Box justifyContent='center'>
                <Box flexDirection='row'>
                    <Box actionIcon onClick={currentPage == 1 ? undefined : () => performPagination(currentPage - 1)} mr='12px' justifyContent='center'>
                        <Small text={'Önceki'} />
                    </Box>

                    {
                        totalPageCount <= 10 ?
                            (
                                Helpers.generateNumberArray(1, totalPageCount).map((i) =>
                                    <PagingItem onClick={() => performPagination(i)} text={i.toString()} active={i == currentPage} />
                                )
                            )
                            :
                            (
                                currentPage < 5 ?
                                    (
                                        <React.Fragment>
                                            {
                                                Helpers.generateNumberArray(1, 5).map((i) =>
                                                    <PagingItem onClick={() => performPagination(i)} text={i.toString()} active={i == currentPage} />
                                                )
                                            }
                                            <PagingItem onClick={undefined} text={'...'} active={false} />
                                            <PagingItem onClick={() => performPagination(totalPageCount)} text={totalPageCount.toString()} active={totalPageCount == currentPage} />
                                        </React.Fragment>
                                    )
                                    :
                                    currentPage > (totalPageCount - 4) ?
                                        (
                                            <React.Fragment>
                                                <PagingItem onClick={() => performPagination(1)} text={"1"} active={1 == currentPage} />
                                                <PagingItem onClick={undefined} text={'...'} active={false} />
                                                {
                                                    Helpers.generateNumberArray(totalPageCount - 5, totalPageCount).map((i) =>
                                                        <PagingItem onClick={() => performPagination(i)} text={i.toString()} active={i == currentPage} />
                                                    )
                                                }
                                            </React.Fragment>

                                        )
                                        :
                                        (
                                            <React.Fragment>
                                                <PagingItem onClick={() => performPagination(1)} text={"1"} active={1 == currentPage} />
                                                <PagingItem onClick={undefined} text={'...'} active={false} />
                                                <PagingItem onClick={() => performPagination((currentPage - 1))} text={(currentPage - 1).toString()} active={currentPage - 1 == currentPage} />
                                                <PagingItem onClick={() => performPagination((currentPage))} text={(currentPage).toString()} active={currentPage == currentPage} />
                                                <PagingItem onClick={() => performPagination((currentPage + 1))} text={(currentPage + 1).toString()} active={currentPage + 1 == currentPage} />
                                                <PagingItem onClick={undefined} text={'...'} active={false} />
                                                <PagingItem onClick={() => performPagination(totalPageCount)} text={totalPageCount.toString()} active={totalPageCount == currentPage} />
                                            </React.Fragment>
                                        )
                            )
                    }

                    <Box actionIcon onClick={currentPage == totalPageCount || totalPageCount == 0 ? undefined : () => performPagination(currentPage + 1)} ml='12px' justifyContent='center'>
                        <Small text={'Sonraki'} />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default TableFooter;